module.exports = __webpack_public_path__ + "static/media/Program9.2689c81a.jpg";